(function() {
  var root = document.getElementById('veloure-product-page');
  if (!root) return;

  /* Product Images for Gallery */
  var images = [
    "https://cdn.shopify.com/s/files/1/0908/4230/0729/files/Vitc_new.jpg?v=1781734414",
    "https://cdn.shopify.com/s/files/1/0908/4230/0729/files/Vitamin_C_result.jpg?v=1781783954",
    "https://cdn.shopify.com/s/files/1/0908/4230/0729/files/vitcplus_box.jpg?v=1781734452",
    "https://cdn.shopify.com/s/files/1/0908/4230/0729/files/Vit_c_new2.jpg?v=1781734436"
  ];

  /* Product Data - Sensitive Skin Vitamin C with Alpha Arbutin */
  var productData = {
    title: "Sensitive Skin Vitamin C with Alpha Arbutin",
    price: 25.00,
    comparePrice: 33.00,
    variantId: 52357791678777,
    image: images[0],
    handle: "vitamin-c-sensitive-skin-serum"
  };

  /* WhatsApp Business Number - digits only for wa.me */
  var WHATSAPP_NUMBER = "96181955615";

  /* Delivery fee for orders under $60 */
  var DELIVERY_FEE = 4.00;
  var FREE_DELIVERY_THRESHOLD = 60.00;

  var currentIndex = 0;
  var quantity = 1;

  var mainImg = root.querySelector('#veloure-main-img');
  var dotsContainer = root.querySelector('#veloure-dots');
  var prevBtn = root.querySelector('#veloure-prev');
  var nextBtn = root.querySelector('#veloure-next');
  var quantityValue = root.querySelector('#veloure-quantity-value');
  var qtyDecrease = root.querySelector('#veloure-qty-decrease');
  var qtyIncrease = root.querySelector('#veloure-qty-increase');
  var addToCartBtn = root.querySelector('#veloure-add-to-cart');
  var buyNowBtn = root.querySelector('#veloure-buy-now');
  var whatsappBtn = root.querySelector('#veloure-whatsapp-btn');
  var successDiv = root.querySelector('#veloure-cart-success');
  var heroPrice = root.querySelector('#veloure-hero-price');
  var heroCompare = root.querySelector('#veloure-hero-compare');
  var heroBadge = root.querySelector('#veloure-hero-badge');

  function money(value) {
    return '$' + Number(value).toFixed(2);
  }

  function updateHeroPrice() {
    if (heroPrice) {
      heroPrice.textContent = money(productData.price);
    }

    if (heroCompare) {
      heroCompare.textContent = money(productData.comparePrice);
    }

    if (heroBadge) {
      var saveAmount = Number(productData.comparePrice) - Number(productData.price);
      heroBadge.textContent = saveAmount > 0 ? 'Save $' + saveAmount.toFixed(0) : '';
      heroBadge.style.display = saveAmount > 0 ? 'inline-flex' : 'none';
    }
  }

  function renderDots() {
    if (!dotsContainer) return;

    dotsContainer.innerHTML = '';

    for (var i = 0; i < images.length; i++) {
      (function(index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'veloure-dot';
        dot.setAttribute('aria-label', 'Show product image ' + (index + 1));

        if (index === currentIndex) {
          dot.classList.add('active');
        }

        dot.addEventListener('click', function(event) {
          event.preventDefault();
          showImage(index);
        });

        dotsContainer.appendChild(dot);
      })(i);
    }
  }

  function updateActiveDots() {
    if (!dotsContainer) return;

    var dots = dotsContainer.querySelectorAll('.veloure-dot');

    for (var i = 0; i < dots.length; i++) {
      if (i === currentIndex) {
        dots[i].classList.add('active');
      } else {
        dots[i].classList.remove('active');
      }
    }
  }

  function showImage(index) {
    currentIndex = (index + images.length) % images.length;
    var url = images[currentIndex];

    if (mainImg) {
      mainImg.src = url;
      mainImg.removeAttribute('srcset');
    }

    productData.image = url;
    updateActiveDots();
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function(event) {
      event.preventDefault();
      showImage(currentIndex - 1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function(event) {
      event.preventDefault();
      showImage(currentIndex + 1);
    });
  }

  /* Touch swipe for mobile */
  var startX = 0;
  var startY = 0;

  if (mainImg) {
    mainImg.addEventListener('touchstart', function(event) {
      if (!event.touches || !event.touches.length) return;

      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });

    mainImg.addEventListener('touchend', function(event) {
      if (!event.changedTouches || !event.changedTouches.length) return;

      var diffX = event.changedTouches[0].clientX - startX;
      var diffY = event.changedTouches[0].clientY - startY;

      if (Math.abs(diffX) > 40 && Math.abs(diffX) > Math.abs(diffY)) {
        showImage(currentIndex + (diffX > 0 ? -1 : 1));
      }
    }, { passive: true });
  }

  function updateQuantityDisplay() {
    if (quantityValue) {
      quantityValue.textContent = quantity;
    }
  }

  function increaseQuantity() {
    quantity = quantity + 1;
    updateQuantityDisplay();
  }

  function decreaseQuantity() {
    if (quantity > 1) {
      quantity = quantity - 1;
      updateQuantityDisplay();
    }
  }

  if (qtyDecrease) {
    qtyDecrease.addEventListener('click', function(event) {
      event.preventDefault();
      decreaseQuantity();
    });
  }

  if (qtyIncrease) {
    qtyIncrease.addEventListener('click', function(event) {
      event.preventDefault();
      increaseQuantity();
    });
  }

  function showMessage(message, isError) {
    if (!successDiv) return;

    successDiv.textContent = message;
    successDiv.style.color = isError ? '#E53E3E' : '#C2A86A';
    successDiv.classList.add('show');

    window.setTimeout(function() {
      successDiv.classList.remove('show');
      successDiv.style.color = '#C2A86A';
    }, 2200);
  }

  function updateCartBubbleCount(count) {
    var cartIcon = document.querySelector('#cart-icon-bubble');

    if (!cartIcon) return;

    var bubble = cartIcon.querySelector('.cart-count-bubble');

    if (count > 0) {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
        cartIcon.appendChild(bubble);
      }

      var visibleCount = bubble.querySelector('span[aria-hidden="true"]') || bubble.querySelector('span');
      var hiddenCount = bubble.querySelector('.visually-hidden');

      if (visibleCount) {
        visibleCount.textContent = count;
      }

      if (hiddenCount) {
        hiddenCount.textContent = count + (count === 1 ? ' item' : ' items');
      }
    } else if (bubble) {
      bubble.remove();
    }
  }

  async function refreshCartIcon() {
    try {
      var cartResponse = await fetch('/cart.js', {
        headers: {
          'Accept': 'application/json'
        }
      });

      if (cartResponse.ok) {
        var cart = await cartResponse.json();

        if (cart && typeof cart.item_count !== 'undefined') {
          updateCartBubbleCount(cart.item_count);
        }
      }
    } catch (error) {}

    try {
      var sectionResponse = await fetch(window.location.pathname + '?sections=cart-icon-bubble', {
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!sectionResponse.ok) return;

      var sections = await sectionResponse.json();

      if (!sections || !sections['cart-icon-bubble']) return;

      var currentIcon = document.querySelector('#cart-icon-bubble');
      var temp = document.createElement('div');
      temp.innerHTML = sections['cart-icon-bubble'];
      var newIcon = temp.querySelector('#cart-icon-bubble');

      if (currentIcon && newIcon) {
        currentIcon.innerHTML = newIcon.innerHTML;
      }
    } catch (error) {}
  }

  async function addToCart() {
    if (!addToCartBtn) return;

    var originalText = addToCartBtn.textContent;
    addToCartBtn.disabled = true;
    addToCartBtn.textContent = 'Adding...';

    try {
      var cartProductData = {
        title: productData.title,
        variant: null,
        price: productData.price,
        variantId: productData.variantId,
        quantity: quantity,
        image: images[currentIndex],
        handle: productData.handle
      };

      if (typeof window.addToCart === 'function') {
        window.addToCart(cartProductData);
        showMessage(quantity + ' × ' + productData.title + ' added to cart successfully!', false);
        await refreshCartIcon();
      } else if (typeof window.addToCartVeloure === 'function') {
        window.addToCartVeloure(cartProductData);
        showMessage(quantity + ' × ' + productData.title + ' added to cart successfully!', false);
        await refreshCartIcon();
      } else {
        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: Number(productData.variantId),
            quantity: Number(quantity)
          })
        });

        if (!response.ok) {
          throw new Error('Add to cart failed');
        }

        await refreshCartIcon();

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        window.dispatchEvent(new CustomEvent('cart:refresh'));
        window.dispatchEvent(new CustomEvent('cart:updated'));

        showMessage(quantity + ' × ' + productData.title + ' added to cart successfully!', false);
      }
    } catch(error) {
      showMessage('Error adding to cart. Please try again.', true);
    }

    window.setTimeout(function() {
      if (addToCartBtn) {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = originalText;
      }
    }, 900);
  }

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function(event) {
      event.preventDefault();
      addToCart();
    });
  }

  async function buyNowRedirect() {
    if (!buyNowBtn) return;

    buyNowBtn.disabled = true;
    var originalText = buyNowBtn.textContent;
    buyNowBtn.textContent = 'Redirecting...';

    try {
      var variantIdNum = Number(productData.variantId);
      var finalQty = Number(quantity);

      var addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantIdNum,
          quantity: finalQty
        })
      });

      if (!addResponse.ok) {
        throw new Error('Add to cart failed');
      }

      await refreshCartIcon();
      window.location.href = '/checkout';
    } catch (error) {
      showMessage('Error processing. Redirecting to cart.', true);

      window.setTimeout(function() {
        window.location.href = '/cart';
      }, 800);
    } finally {
      window.setTimeout(function() {
        if (buyNowBtn) {
          buyNowBtn.disabled = false;
          buyNowBtn.textContent = originalText;
        }
      }, 1500);
    }
  }

  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function(event) {
      event.preventDefault();
      buyNowRedirect();
    });
  }

  function sendWhatsAppOrder() {
    var productName = productData.title;
    var productPrice = Number(productData.price);
    var subtotal = productPrice * Number(quantity);
    var isFreeDelivery = subtotal >= FREE_DELIVERY_THRESHOLD;
    var deliveryCost = isFreeDelivery ? 0 : DELIVERY_FEE;
    var totalPrice = subtotal + deliveryCost;
    var deliveryText = isFreeDelivery ? 'Free Delivery' : '$' + DELIVERY_FEE.toFixed(2) + ' Delivery';
    var message = 'Hello, I am interested in ' + productName + ' for quantity ' + quantity + ' and ' + deliveryText + ' for a total of $' + totalPrice.toFixed(2);
    var whatsappUrl = 'https://wa.me/' + WHATSAPP_NUMBER + '?text=' + encodeURIComponent(message);

    window.open(whatsappUrl, '_blank');
  }

  if (whatsappBtn) {
    whatsappBtn.addEventListener('click', function(event) {
      event.preventDefault();
      sendWhatsAppOrder();
    });
  }

  async function addUpsellToCart(variantId, title, price, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    var btn = event ? event.currentTarget : null;
    var originalHTML = btn ? btn.innerHTML : '';

    if (btn) {
      btn.disabled = true;
      btn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"></path></svg><span>Adding...</span>';
    }

    try {
      var cartProductData = {
        title: title,
        variant: null,
        price: Number(price),
        variantId: variantId,
        quantity: 1,
        image: '',
        handle: ''
      };

      if (typeof window.addToCart === 'function') {
        window.addToCart(cartProductData);
        showMessage(title + ' added to cart successfully!', false);
        await refreshCartIcon();
      } else if (typeof window.addToCartVeloure === 'function') {
        window.addToCartVeloure(cartProductData);
        showMessage(title + ' added to cart successfully!', false);
        await refreshCartIcon();
      } else {
        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: 1
          })
        });

        if (!response.ok) {
          throw new Error('Upsell add to cart failed');
        }

        await refreshCartIcon();

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        window.dispatchEvent(new CustomEvent('cart:refresh'));
        window.dispatchEvent(new CustomEvent('cart:updated'));

        showMessage(title + ' added to cart successfully!', false);
      }
    } catch(error) {
      showMessage('Error adding to cart. Please try again.', true);
    }

    window.setTimeout(function() {
      if (btn) {
        btn.disabled = false;
        btn.innerHTML = originalHTML;
      }
    }, 900);
  }

  var upsellButtons = root.querySelectorAll('.upsell-add-btn');

  for (var u = 0; u < upsellButtons.length; u++) {
    (function(button) {
      var card = button.closest ? button.closest('.upsell-card') : null;

      if (!card) return;

      var variantId = card.getAttribute('data-upsell-variant-id');
      var title = card.getAttribute('data-upsell-title');
      var price = card.getAttribute('data-upsell-price');

      button.addEventListener('click', function(event) {
        addUpsellToCart(variantId, title, price, event);
      });
    })(upsellButtons[u]);
  }

  var reviewsLink = root.querySelector('#veloure-reviews-link');

  if (reviewsLink) {
    reviewsLink.addEventListener('click', function() {
      var target = document.getElementById('shopify-product-reviews') || document.querySelector('[data-reviews]');

      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  }

  function initCollapsibles() {
    var collapsibles = root.querySelectorAll('.veloure-collapsible');

    for (var i = 0; i < collapsibles.length; i++) {
      (function(collapsible) {
        var header = collapsible.querySelector('.veloure-collapsible-header');
        var content = collapsible.querySelector('.veloure-collapsible-content');
        var iconSpan = collapsible.querySelector('.veloure-collapsible-icon');

        if (!header || !content || !iconSpan) return;

        header.addEventListener('click', function(event) {
          event.preventDefault();

          var isOpen = content.classList.contains('open');

          if (isOpen) {
            content.classList.remove('open');
            iconSpan.textContent = '+';
          } else {
            content.classList.add('open');
            iconSpan.textContent = '−';
          }
        });

        content.classList.remove('open');
        iconSpan.textContent = '+';
      })(collapsibles[i]);
    }
  }

  updateHeroPrice();
  renderDots();
  showImage(0);
  updateQuantityDisplay();
  initCollapsibles();
})();
